import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import AnmodningStatusPill from './AnmodningStatusPill';

const useStyles = makeStyles(theme => ({
  columnContainer: {
    padding: theme.spacing(1),
  },
  column: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  columnTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    fontSize: '14px',
    borderBottom: '1px solid #d3d3df',
    paddingBottom: theme.spacing(0.5),
  },
  details: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: "11px", 
    width: "100%",
  },
  detailsHeader: {
    width: "45%",
    fontWeight: "500",
    alignItems: "center",
  },
  detailsValue: {
    width: "55%",
    marginLeft: "8px"
  }
}));

const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${day}-${month}-${year} ${hours}:${minutes}`;
};

const calculateElapsedMinutes = (startDateString, endDateString) => {
  if (!startDateString || !endDateString) return null;
  const startDate = new Date(startDateString);
  const endDate = new Date(endDateString);
  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return null;
  
  const diffMs = endDate - startDate;
  const diffMinutes = Math.floor(diffMs / 60000);
  return diffMinutes;
};

const titleGenerelt = 'Generelt';
const keywordsGenerelt = {
  'anmod_status': 'Status',
  'anmod_ansvar': 'Ansvar',
  'graveforespoergselsnr': 'Nummer',
  'interesseomraadeid': 'Område id',
  'oprettet_dato': 'Oprettet',
  'svar_dato': 'Svar',
  'kvitteret_dato': 'Kvitteret',
  'bemaerkning': 'Bemærkning'
}

const titleAktoer = 'Aktør';
const keywordsAktoer = {
  'aktoer_navn': 'Aktør',
  'aktoer_mail': 'mail',
  'aktoer_postnr': 'postnr',
  'aktoer_postdistrikt': 'Postdistrikt',
  'aktoer_adresse': 'Adresse',
  'aktoer_virksomhed': 'Virksomhed',
  'aktoer_telefon': 'Telefon nr',
  'aktoer_mobil': 'Mobil nr',
  'aktoer_kontakt_navn': 'Kontakt person',
  'aktoer_kontakt_mail': 'Kontakt mail',
  'aktoer_kontakt_postnr': 'Kontakt postnr'
}
const titleGrav = 'Gravning';
const keywordsGrav = {
  "graveart": "Grave art",
  "forsyningsart": "Forsynings art",
  "formaal": "Formål",
  "graveperiode_fra": "Starter",
  "graveperiode_til": "Slutter",
  "source": "Source (?)"
}

export default function AnmodningInformation(props) {
  const classes = useStyles();
  
  if (!props.Anmodning)
    return (<div></div>);

  const formatValue = (key, value) => {
    // Format date fields
    if (key === 'oprettet_dato' || key === 'svar_dato' || key === 'kvitteret_dato') {
      return formatDateTime(value);
    }

    // Format status field
    if (key === 'anmod_status') {
      return <AnmodningStatusPill status={value} style={{ fontSize: '11px' }} />;
    }

    return value;
  };

  const keywordGenerelt = Object.entries(keywordsGenerelt);
  const entriesGenerelt = Object.entries(props.Anmodning).filter(([key]) => {
    return keywordGenerelt.some(([keywordKey]) => keywordKey === key);
  });
  
  // Calculate elapsed time if both dates exist
  const elapsedMinutes = calculateElapsedMinutes(
    props.Anmodning.oprettet_dato, 
    props.Anmodning.kvitteret_dato
  );

  const keywordAktoer = Object.entries(keywordsAktoer);
  const entriesAktoer = Object.entries(props.Anmodning).filter(([key]) => {
    return keywordAktoer.some(([keywordKey]) => keywordKey === key);
  });
  const keywordGrav = Object.entries(keywordsGrav);
  const entriesGrav = Object.entries(props.Anmodning).filter(([key]) => {
    return keywordGrav.some(([keywordKey]) => keywordKey === key);
  });


  return (
    <Grid item container spacing={2} className={classes.columnContainer}>
      <Grid item xs={12} md={4} className={classes.column}>
        <Typography className={classes.columnTitle}>{titleGenerelt}</Typography>
        {entriesGenerelt.map(([key, value]) => (
          <div key={key} className={classes.details}>
            <label className={classes.detailsHeader}><strong>{keywordsGenerelt[key]}</strong></label>
            <span className={classes.detailsValue}>{formatValue(key, value)}</span>
          </div>
        ))}
        {elapsedMinutes !== null && (
          <div className={classes.details}>
            <label className={classes.detailsHeader}><strong>Behandlingstid</strong></label>
            <span className={classes.detailsValue}>{elapsedMinutes} minutter</span>
          </div>
        )}
      </Grid>

      <Grid item xs={12} md={4} className={classes.column}>
        <Typography className={classes.columnTitle}>{titleAktoer}</Typography>
        {entriesAktoer.map(([key, value]) => (
          <div key={key} className={classes.details}>
            <label className={classes.detailsHeader}><strong>{keywordsAktoer[key]}</strong></label>
            <span className={classes.detailsValue}>{value}</span>
          </div>
        ))}
      </Grid>

      <Grid item xs={12} md={4} className={classes.column}>
        <Typography className={classes.columnTitle}>{titleGrav}</Typography>
        {entriesGrav.map(([key, value]) => (
          <div key={key} className={classes.details}>
            <label className={classes.detailsHeader}><strong>{keywordsGrav[key]}</strong></label>
            <span className={classes.detailsValue}>{value}</span>
          </div>
        ))}
      </Grid>
    </Grid>
  );
}